import React from 'react';
import Header from '../../layouts/Header';
import ClientList from '../../clients/list/ClientList';

const Home = () => {

  return (
    <>
      <Header />
      <ClientList/>
    </>
  );
};

export default Home;
